import { ActionContext, Module } from 'vuex';
import { ajax } from '@/util/ajax';

const rebuildList = function (list: any) {
  let result = [];

  if (list) {
    result = list.concat();
    result.forEach((item: any) => {
      item._showChildren = true;

      if (item.children) {
        item.children = rebuildList(item.children);
      }
    });
  }

  return result;
};

const URL = {
  LIST: '/dh-datamaint/questionCatalog/list',
  BATCH_ADD: '/dh-datamaint/questionCatalog/batchAdd',
  DELETE: '/dh-datamaint/questionCatalog/delete',
  DETAIL: '/dh-datamaint/questionCatalog/getById',
  UPDATE: '/dh-datamaint/questionCatalog/update',
  MOVE: '/dh-datamaint/questionCatalog/move',
  ADD_SUBJECT: '/dh-datamaint/questionSubject/add',
  SUBJECT_LIST: '/dh-datamaint/questionSubject/listTreeByVersionId'
};

class CatalogModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getList(context: ActionContext<any, any>, payload: any) {
      const res = await ajax.get(URL.LIST, { params: payload.data });
      return rebuildList(res.data.data);
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.BATCH_ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.DELETE, null, { params: payload.data });
    },

    async Move(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.MOVE, payload.data);
    },

    async AddSubject(context: ActionContext<any, any>, payload: any) {
      await ajax.post(URL.ADD_SUBJECT, payload.data);
    },

    async getSubjectList(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.SUBJECT_LIST, { params: payload.data });
    }
  };
}

export const catalogModule = new CatalogModule();
